import { useEffect, useState } from "react";
import { Compass, PhoneCall, Moon, Sun, Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { id: "ressurser", label: "Ressurser", testid: "nav-link-resources" },
  { id: "kapitler", label: "Kapitler", testid: "nav-link-chapters" },
  { id: "budsjett", label: "Budsjettverktøy", testid: "nav-link-calculator" },
  { id: "gjeld", label: "Gjeldsverktøy", testid: "nav-link-debt-tool" },
  { id: "raadgiver", label: "AI-rådgiver", testid: "nav-link-advisor" },
];

export default function Header() {
  const [dark, setDark] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
  }, [dark]);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header data-testid="nav-header" className="fixed top-0 inset-x-0 z-50 border-b border-border/60 bg-background/80 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <button data-testid="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5 group">
          <span className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center transition-transform duration-300 group-hover:rotate-12">
            <Compass size={16} />
          </span>
          <span className="font-serif font-bold text-lg tracking-tight">Gjeldsveiviseren</span>
        </button>

        <nav className="hidden md:flex items-center gap-1">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={l.testid} onClick={() => go(l.id)}
              className="px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors duration-200 rounded-md hover:bg-accent/60">
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a data-testid="nav-nav-emergency-link" href="tel:55553333"
            className="hidden lg:flex items-center gap-2 text-xs font-mono font-semibold px-3 py-2 rounded-full bg-accent text-accent-foreground hover:bg-primary hover:text-primary-foreground transition-colors duration-200">
            <PhoneCall size={13} /> NAV 55 55 33 33
          </a>
          <button data-testid="theme-toggle-btn" onClick={() => setDark(!dark)} aria-label="Bytt tema"
            className="w-9 h-9 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-colors duration-200">
            {dark ? <Sun size={15} /> : <Moon size={15} />}
          </button>
          <button data-testid="mobile-menu-btn" onClick={() => setOpen(!open)} aria-label="Meny"
            className="md:hidden w-9 h-9 rounded-full border border-border flex items-center justify-center">
            {open ? <X size={15} /> : <Menu size={15} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden border-t border-border/60 bg-background/95 backdrop-blur-md px-4 py-3 flex flex-col gap-1">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`${l.testid}-mobile`} onClick={() => go(l.id)}
              className="text-left px-3 py-2.5 text-sm font-medium rounded-md hover:bg-accent/60 transition-colors">
              {l.label}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
}
